import React from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import { useCountUp } from 'react-countup';
import { useDataContext } from '../../DataContext';
const HpCounters = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { globalData } = useDataContext();
    useCountUp({
        ref: 'crOne',
        start:0,
        end: (globalData) ? globalData.sg_publication_count : 550,
        suffix:'+',
        enableScrollSpy: true,
    });
    useCountUp({
        ref: 'crTwo',
        start:0,
        end: (globalData) ? globalData.sg_alumni_count : 2600,
        suffix:'+',
        enableScrollSpy: true,
    });
    useCountUp({
        ref: 'crThree',
        start:0,
        end: (globalData) ? globalData.sg_student_count : 2800,
        suffix:'+',
        enableScrollSpy: true,
      });
      useCountUp({
        ref: 'crFour',
        start:0,
        end: (globalData) ? globalData.sg_placements_count : 2000,
        suffix:'+',
        enableScrollSpy: true,
      });
    return (
        <section className="hp-counter bg-primary text-white">
            <Container className="py-5 text-center">
                <Row className='g-3' id="countup-target">
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <div className="counters display-3">
                            <span id='crOne' aria-label={appLanguage === 'hi' ? 'कुल प्रकाशन' : 'Total Publications'} />
                        </div>
                        <div className="text">
                            {appLanguage === 'hi' ? 'प्रकाशन' : 'Publications'}
                        </div>
                    </Col>
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <div className="counters display-3">
                            <span id='crTwo' aria-label={appLanguage === 'hi' ? 'कुल भूतपूर्व छात्र' : 'Total Alumni'} />
                        </div>
                        <div className="text">
                            {appLanguage === 'hi' ? 'भूतपूर्व छात्र' : 'Alumni'}
                        </div>
                    </Col>
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <div className="counters display-3">
                            <span id='crThree' aria-label={appLanguage === 'hi' ? 'कुल छात्र' : 'Total Students'} />
                        </div>
                        <div className="text">
                            {appLanguage === 'hi' ? 'छात्र' : 'Students'}
                        </div>
                    </Col>
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <div className="counters display-3">
                            <span id='crFour' aria-label={appLanguage === 'hi' ? 'कुल नियुक्तियाँ' : 'Total Placements'} />
                        </div>
                        <div className="text">
                            {appLanguage === 'hi' ? 'नियुक्तियाँ' : 'Placements'}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
export default HpCounters;